import { IObjectControllableFeature } from "./IObjectControllableFeature";
import { ILinkedPageObjectSpecifiable } from "./ILinkedPageObjectSpecifiable";

export interface ITranscribeDateOfTimeBehaviorSpecifiable {
  transcribeDateOfTimeBehavior: IObjectControllableFeature<ILinkedPageObjectSpecifiable>;
}

export function instanceOfITranscribeDateOfTimeBehaviorSpecifiable(instance: any): instance is ITranscribeDateOfTimeBehaviorSpecifiable {
  return instance
      && (instance.transcribeDateOfTimeBehavior !== undefined);
}
